import { useRef } from 'react';
import { useParams } from 'react-router-dom';

import Container from '@material-ui/core/Container';
import useDownloadTerms from '../../../../hooks/useDownloadTerms'

const FirstBox = () => {
    const ref = useRef();
    const { hashCode } = useParams();
    const [file, isLoadingFile] = useDownloadTerms(hashCode);

    const downloadTerms = () => {
        if (file) {
            ref.current.href = file;
            ref.current.download = 'Términos de confidencialidad.pdf';
            ref.current.click();
        }
    };

    return (
        <Container className="advanced-mobile-box">
            <div className="row">
                <div className="col-md-10 col-sm-12">
                    <span className="title-8">Bienvenido(a)</span>
                    <br/>
                    <span className="text-4">Seguimos procesando la información de tus portales B2B.</span>
                </div>
                <div className="col-md-2 col-sm-12">
                    <div className="d-flex flex-row justify-content-center">
                        <button
                            className="isv-btn isv-btn-lead"
                            onClick={downloadTerms}
                            disabled={isLoadingFile}
                        >
                            Descargar términos
                        </button>
                        <a className="d-none" href="" ref={ref} />
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default FirstBox;
